/**
 * Список тем хотспотов
 * @return Promise
 */
const hotspotThemeList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/hotspotTheme/getList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Объект темы
 * @return Promise
 */
const hotspotTheme = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/hotspotTheme/get",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Добавление темы хотспоту
 * @return Promise
 */
const createHotspotTheme = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/hotspotTheme/create",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Удаление темы у хотспота
 * @return Promise
 */
const deleteHotspotTheme = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/hotspotTheme/delete",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export {
  deleteHotspotTheme,
  createHotspotTheme,
  hotspotTheme,
  hotspotThemeList
};
